import React from 'react';

const HorasTomadas = () => {
    return (
        <div>
        <div className='contenedor-tablas'>

            <table className='mi-tabla'>

                <caption> Alta Con Número de Empleado </caption>
                
                <tr>
                    <td> Acta de Designación (Asamblea) </td>
                </tr>
                <tr>
                    <td> DNI </td>
                </tr>
                <tr>
                    <td> Fotocopia del Título </td>
                </tr>
                <tr>
                    <td> Declaración Jurada de cargos </td>                        
                </tr>
                <tr>
                    <td> Declaración Jurada de Datos Personales  </td>                        
                </tr>
                <tr>
                    <td> Actualización Domicilio </td>                        
                </tr>
                <tr>
                    <td> Cuaderno de actuación </td>                        
                </tr>

            </table>

            <table className='mi-tabla'>

                <caption> Alta Sin Número de Empleado </caption>

                <tr>
                    <td> Acta de Designación (Asamblea) </td>
                </tr>
                <tr>
                    <td> DNI </td>
                </tr>
                <tr>
                    <td> Fotocopia del Título </td>
                </tr>
                <tr>
                    <td> Declaración Jurada de cargos </td>                        
                </tr>
                <tr>
                    <td> Declaración Jurada de Datos Personales  </td>                        
                </tr>
                <tr>
                    <td> Actualización Domicilio </td>                        
                </tr>
                <tr>
                    <td> Circular N°19 </td>                        
                </tr>
                <tr>
                    <td> Certificado de Antecedentes Policiales (Provincial y Nacional) </td>                        
                </tr>
                <tr>
                    <td> Constancia de CUIL </td>                        
                </tr>
                <tr>
                    <td> Constancia de últimos Votos o Constancia de no Infractor </td>                        
                </tr>
                <tr>
                    <td> Certificado médico de aptitud física </td>                        
                </tr>
                <tr>
                    <td> Cuaderno de actuación </td>                        
                </tr>

            </table>

            </div>
        </div>
    );
}

export default HorasTomadas;


